<template>
  <div class="container__">
    <img :src="imgSrc" width="100%" height="100%" class="bg__img" alt="" />
    <div class="login">
      <div class="login_box">
        <div class="login__item">
          <div class="login__name">
            {{ count == 1 ? "账号登录" : "账号注册" }}
          </div>
          <el-form :model="LoginForm" :rules="LoginRules" ref="LoginForm">
            <div class="form__item">
              <div class="item__name">
                <img src="../../assets/img/jin_1.png" alt="" />
              </div>
              <div class="inputed__form">
                <el-form-item prop="mobile">
                  <el-input
                    placeholder="请输入您的身份证号"
                    v-model="LoginForm.mobile"
                    class="el_iput"
                    maxlength="18"
                    autocomplete="off"
                    clearable
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form__item">
              <div class="item__name">
                <img src="../../assets/img/jin_2.png" alt="" />
              </div>
              <div class="inputed__form">
                <el-form-item prop="password">
                  <el-input
                    placeholder="请输入密码"
                    v-model="LoginForm.password"
                    class="el_iput"
                    type="password"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form__item" v-if="count == 2">
              <div class="item__name">
                <img src="../../assets/img/jin_2.png" alt="" />
              </div>
              <div class="inputed__form">
                <el-form-item prop="ispassword">
                  <el-input
                    placeholder="请再次输入密码"
                    v-model="LoginForm.ispassword"
                    class="el_iput"
                    type="password"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form__item">
              <div class="item__name">
                <img src="../../assets/img/jin_3.png" alt="" />
              </div>
              <div class="inputed__form code__form">
                <el-form-item prop="passcode">
                  <el-input
                    placeholder="请输入验证码"
                    class="el_iput"
                    v-model="LoginForm.passcode"
                  />
                </el-form-item>
                <div class="yan__code">
                  <img :src="codeimg" alt="" @click.stop="onclisking" />
                </div>
              </div>
            </div>
            <div class="pass__list" v-if="count == 1">
              <div class="left_remember" @click.stop="clickRemember">
                <div class="img_changed">
                  <img
                    src="../../assets/img/jin_4.png"
                    v-if="remember == 0"
                    alt=""
                  />
                  <img src="../../assets/img/jin_5.png" v-else alt="" />
                </div>
                <div
                  class="remember__name"
                  :class="remember == 0 ? '' : 'is_remember'"
                >
                  记住密码
                </div>
              </div>
              <div class="forget_name" @click="forgetPass">忘记密码？</div>
            </div>
            <div class="form__button">
              <el-button
                class="el__buton"
                v-if="count == 1"
                @click="submitForm('LoginForm')"
                >确认登录</el-button
              >
              <el-button
                class="el__buton"
                v-if="count == 2"
                @click="registerForm('LoginForm')"
                >立即注册</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
      <div class="ww__logp">
        <div class="w sf">
          <div class="img__logo" @click="goHome">
            <!-- <img
              src="../../assets/img/img_12.png"
              class="img_logo_post"
              alt=""
            /> -->
            <h1 class="logg__name">{{ logoName }}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// 引入base64
const Base64 = require('js-base64').Base64
export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('帐号不能为空'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };

    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    // 验证密码
    // var validatePass = (rule, value, callback) => {
    //   var passwordreg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
    //   if (value === '') {
    //     callback(new Error("请输入密码"));
    //   } else if (!passwordreg.test(value)) {
    //     callback(new Error('请输入6-16位的密码，需包含数字、字母'))
    //   } else {
    //     if (this.LoginForm.repassword !== '') {
    //       this.$refs.LoginForm.validateField("repassword");
    //     }
    //     callback();
    //   }
    // };
    var validateIspass = (rule, value, callback) => {
      // console.log(this.LoginForm.repassword);
      // console.log(value, "vlaue", rule, "rule", "新密码");
      if (value === '') {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.LoginForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      logoName: this.Public.logo_name,
      bei_ing: 'img_11.png',
      imgSrc: this.Public.imgSrc,
      remember: 0,
      codeimg: '',
      count: 1,
      captcha_id: '',
      LoginForm: {
        mobile: '',
        password: '',
        ispassword: '',
        passcode: '',
      },
      LoginRules: {
        mobile: [{ validator: validateMobile, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: "blur" }],
        ispassword: [{ validator: validateIspass, trigger: "blur" }],
        passcode: [{ validator: validateCode, trigger: "blur" }],
      },
    }
  },
  created() {
    // 在页面加载时从cookie获取登录信息
    let mobile = this.getCookie("mobile"),
      remember = this.getCookie("remember"),
      password = Base64.decode(this.getCookie("password"));
    if (remember) {   // 如果存在赋值给表单，并且将记住密码勾选
      this.LoginForm.mobile = mobile
      this.LoginForm.password = password
      this.remember = remember
    }
    // // console.log(mobile, password);
    if (this.$route.query && this.$route.query.num) {
      let query = this.$route.query
      // console.log(query, "query");
      this.count = query.num
    }
    this.getcodeImg()
  },
  methods: {
    ...mapActions(['userinfo', 'isclickLogin']),
    submitForm(formName) {   // 登录
      this.$refs[formName].validate((valid) => {
        // console.log(formName);   // 代表要提交的表单数据 是 LoginForm 对象
        if (valid) {
          // console.log(valid, "valid");
          let url = '/lists/password_login',
            param = {
              username: this.LoginForm.mobile,
              password: this.LoginForm.password,
              code: this.LoginForm.passcode,
              code_id: this.captcha_id,
              type: this.remember
            }
          this.post(url, param).then(res => {
            // console.log(res);
            if (res.code == 1) {
              this.$message.success(res.msg)
              localStorage.setItem('token-qzb', res.data.token)
              setTimeout(() => {
                this.userinfo(res.data)
                this.isclickLogin(true)
                this.$router.go(-1)
              }, 300);
            } else {
              this.$message.error(res.msg || '登录失败')
            }
          }).catch(err => {
            // console.log(err);
            this.$message.error((err && err.msg) || '网络异常，登录失败，请重试')
          })
        }
      })
    },
    registerForm(formName) {   //   注册
      this.$refs[formName].validate((valid) => {
        // console.log(formName);   // 代表要提交的表单数据 是 LoginForm 对象
        if (valid) {
          // console.log(valid, "valid");
          let url = '/lists/register',
            param = {
              username: this.LoginForm.mobile,
              password: this.LoginForm.password,
              code: this.LoginForm.passcode,
              code_id: this.captcha_id
            }
          this.post(url, param).then(res => {
            // console.log(res);
            if (res.code == 1) {
              this.$message.success(res.msg)
            }
            setTimeout(() => {
              // this.$router.go(-1)
            }, 300);
          }).catch(err => {
            // console.log(err);
            this.$message.error((err && err.msg) || '网络异常，注册失败，请重试')
          })
        }
      })
    },
    forgetPass() {   // 忘记密码
      this.$router.push('/forget')
    },
    clickRemember() {   // 记住密码
      if (this.remember == 1) {
        this.remember = 0
      } else {
        this.remember = 1
        this.setUserInfo()
      }
    },
    setUserInfo() {   // 储存表单信息
      if (this.remember) {
        this.setCookie("mobile", this.LoginForm.mobile)
        let password = Base64.encode(this.LoginForm.password)   // base64加密密码
        this.setCookie("remember", this.remember)
        this.setCookie("password", password)
      } else {
        this.setCookie("mobile", "")
        this.setCookie("password", "")
        this.setCookie("remember", "0")
      }
    },
    getCookie(key) {   // 获取cookie
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + '=')
        if (start !== -1) {
          start = start + key.length + 1
          var end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },
    setCookie(cName, value, expiredays) {      // 保存cookie
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = cName + '=' + decodeURIComponent(value) +
        ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
    },
    goHome() {
      this.$router.push('/')
    },
    async getcodeImg() {
      let url = 'lists/getCaptcha'
      try {
        const { data } = await this.post(url)
        // console.log(data);
        this.codeimg = data.captcha
        this.captcha_id = data.captcha_id
      } catch (err) {
        // console.log(err)
        this.$message.error(err.msg || err.data.msg)
      }
    },
    onclisking() {
      this.getcodeImg()
    },

  },
}
</script>

<style lang="less" scoped>
.container__ {
  width: 100%;
  height: 100%;

  .bg__img {
    width: 100%;
    height: 100%; /**宽高100%是为了图片铺满屏幕 */
    z-index: -1;
    position: absolute;
  }

  .login {
    width: 100%;
    height: 100%;

    .login_box {
      width: 400px;
      height: 460px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .login__item {
        width: 100%;
        padding: 33px 44px;
        box-sizing: border-box;

        .login__name {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 700;
          color: #06121e;
          line-height: 24px;
          margin-bottom: 30px;
        }

        .form__item {
          height: 44px;
          width: 100%;
          display: flex;
          align-items: center;
          border-radius: 22px;
          box-sizing: border-box;
          background: #edf4fd;
          margin-bottom: 26px;

          .item__name {
            // width: 40px;
            padding: 0 10px 0 16px;
            box-sizing: border-box;

            img {
              width: 24px;
              height: 24px;
            }
          }

          .inputed__form {
            flex: 1;
          }
          .code__form {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .yan__code {
              width: 160px;
              height: 44px;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 100%;
                height: 40px;
                border-radius: 20px;
              }
            }
          }
        }

        .pass__list {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 26px;
          box-sizing: border-box;

          .left_remember {
            display: flex;
            align-items: center;
            .img_changed {
              width: 14px;
              height: 14px;
              margin-right: 5px;

              img {
                width: 100%;
              }
            }

            .remember__name {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #5b5e63;
              line-height: 24px;
            }

            .is_remember {
              color: #198bf8;
            }
          }

          .forget_name {
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: right;
            color: #5b5e63;
            line-height: 24px;
          }
        }

        .form__button {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 30px;

          .el__buton {
            width: 296px;
            height: 40px;
            background: #3e8bff !important;
            border-radius: 20px;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .ww__logp {
      width: 100%;

      .sf {
        position: relative;

        .img__logo {
          width: 100%;
          position: absolute;
          top: 70px;
          z-index: 2;

          .img_logo_post {
            // width: 180px;
            height: 65px;
          }
          .logg__name {
            height: 65px;
            font-size: 44px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>